<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.daily.rate.title')"
        :field-author-and-date="qualification.commentOnDailyRate"
        data-testid="admin-section-tabs-qualification-daily-rate"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.commentOnDailyRate"
            :placeholder="$t('profile.vetting.qualification.daily.rate.placeholder')"
            autogrow
            data-testid="vetting-daily-rate-edition"
        ></VJoyTextarea>
        <TextField
            v-else
            :content="profileQualificationStore.qualificationUpdateForm.commentOnDailyRate"
            :replace-by="$t('profile.vetting.qualification.daily.rate.empty.placeholder')"
            data-testid="vetting-daily-rate"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);
</script>
